var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, PropSync } from 'vue-property-decorator';
import { uniq, isEmpty } from 'lodash';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { addExcludedCnpjs, cleanExcludedCnpjs, listExcludedCnpjs, removeExcludedCnpjs, } from '@/clients/excluded_cnpjs';
import Pagination from '@/components/Pagination.vue';
import Modal from '@/components/Modal.vue';
import CleanExcludedCnpjsConfirm from './CleanExcludedCnpjsConfirm.vue';
let SearchFilterNegativeCnpjs = class SearchFilterNegativeCnpjs extends Vue {
    constructor() {
        super(...arguments);
        this.selectedValues = [];
        this.options = [];
        this.cnpjs = [];
        this.page = 1;
        this.totalCnpjs = 0;
        this.search = '';
        this.waiting = false;
        this.showRemoveCnpjsConfirm = false;
    }
    mounted() {
        this.fetchCnpjs();
    }
    async fetchCnpjs() {
        this.waiting = true;
        try {
            const response = await listExcludedCnpjs({
                page: this.page,
                search: this.search,
            });
            this.cnpjs = response.data.cnpjs;
            this.totalCnpjs = response.data.total;
        }
        catch (e) {
            console.log(e);
        }
        this.waiting = false;
    }
    async addCnpjs() {
        this.waiting = true;
        try {
            await addExcludedCnpjs(this.selectedValues);
            this.resetOptions();
            await this.fetchCnpjs();
        }
        catch (e) {
            console.log(e);
        }
        this.waiting = false;
    }
    openRemoveCnpjsConfirm() {
        this.showRemoveCnpjsConfirm = true;
    }
    async removeCnpjsSelecteds() {
        this.waiting = true;
        try {
            await removeExcludedCnpjs(this.selectedValues);
            this.resetOptions();
            await this.fetchCnpjs();
        }
        catch (e) {
            console.log(e);
        }
        this.waiting = false;
    }
    async removeCnpjsSelected(cnpj) {
        this.waiting = true;
        try {
            await removeExcludedCnpjs([cnpj]);
            this.cnpjs = this.cnpjs.filter(cnpj_ => cnpj_ !== cnpj);
            this.totalCnpjs -= 1;
            if (this.cnpjs.length == 0) {
                this.page -= 1;
                await this.fetchCnpjs();
            }
        }
        catch (e) {
            console.log(e);
        }
        this.waiting = false;
    }
    async cleanCnpjs() {
        this.waiting = true;
        try {
            await cleanExcludedCnpjs();
            this.page = 1;
            await this.fetchCnpjs();
        }
        catch (e) {
            console.log(e);
        }
        this.waiting = false;
    }
    resetOptions() {
        this.selectedValues = [];
        this.options = [];
        this.page = 1;
    }
    get totalPages() {
        return Math.ceil(this.totalCnpjs / 50);
    }
    setPageNumber(page) {
        this.page = page;
        this.fetchCnpjs();
    }
    addCnpj(text) {
        text.split(' ').forEach(spaceSplit => {
            spaceSplit.split(',').forEach(commaSplit => {
                commaSplit.split(';').forEach(semicolonSplit => {
                    semicolonSplit.split('\n').forEach(tag => {
                        const onlyNumbers = tag.replace(/\D+/g, '');
                        if (!onlyNumbers)
                            return false;
                        const cnpjs = this.lJustify(onlyNumbers, 14, '0');
                        if (!this.selectedValues.includes(cnpjs)) {
                            this.selectedValues.push(cnpjs);
                        }
                    });
                });
            });
        });
        this.selectedValues = this.sanitizeCnpjs(this.selectedValues);
        this.options = this.selectedValues;
    }
    removedCnpj(cnpjs) {
        this.selectedValues = cnpjs;
        this.options = cnpjs;
    }
    lJustify(str, targetLength, paddingString = ' ') {
        let newString = str;
        while (newString.length < targetLength) {
            newString = paddingString + newString;
        }
        return newString;
    }
    sanitizeCnpjs(cnpjs) {
        return uniq(cnpjs).filter(cnpj => !isEmpty(cnpj));
    }
};
__decorate([
    PropSync('open', { default: false })
], SearchFilterNegativeCnpjs.prototype, "showNegatedModal", void 0);
SearchFilterNegativeCnpjs = __decorate([
    Component({
        name: 'SearchFilterNegativeCnpjs',
        components: { Multiselect, Pagination, Modal, CleanExcludedCnpjsConfirm },
    })
], SearchFilterNegativeCnpjs);
export default SearchFilterNegativeCnpjs;
